export enum LockerKeyState {
  FREE = 'FREE',
  ISSUED = 'ISSUED',
  DISABLED = 'DISABLED',
}

export enum LockerKeyHolderType {
  USER = 'USER',
  PROSPECT = 'PROSPECT',
}

export enum LockerKeyReleaseReason {
  RETURNED = 'RETURNED',
  REPLACED = 'REPLACED',
  DISABLED = 'DISABLED',
  /** Released by the desk without the key coming back (Celina 2.14): the
   * default release of an overdue key and every row of the morning bulk. */
  NOT_RETURNED = 'NOT_RETURNED',
}

export enum LockerKeyDisableReason {
  LOST = 'LOST',
  DAMAGED = 'DAMAGED',
  OTHER = 'OTHER',
}

export enum LockerKeyWarning {
  NO_ARRIVAL_TODAY = 'NO_ARRIVAL_TODAY',
}

/** Wire values of the `code` field on locker-key business errors; the BE
 * throws them and the FE branches on them, so both import this one table. */
export enum LockerKeyApiErrorCode {
  KEY_ISSUED = 'LOCKER_KEY_ISSUED',
  KEY_DISABLED = 'LOCKER_KEY_DISABLED',
  HOLDER_HAS_KEY = 'LOCKER_KEY_HOLDER_HAS_KEY',
  LAST_GROUP = 'LOCKER_KEY_LAST_GROUP',
  GROUP_HAS_ISSUED_KEY = 'LOCKER_KEY_GROUP_HAS_ISSUED_KEY',
  RANGE_EXCLUDES_ISSUED_KEY = 'LOCKER_KEY_RANGE_EXCLUDES_ISSUED_KEY',
  GROUP_LIMIT = 'LOCKER_KEY_GROUP_LIMIT',
  GROUP_NAME_TAKEN = 'LOCKER_KEY_GROUP_NAME_TAKEN',
  KEY_ALREADY_DISABLED = 'LOCKER_KEY_ALREADY_DISABLED',
  CURRENT_ASSIGNMENT_CHANGED = 'LOCKER_KEY_CURRENT_ASSIGNMENT_CHANGED',
  NUMBER_OUT_OF_RANGE = 'LOCKER_KEY_NUMBER_OUT_OF_RANGE',
  GROUP_ARCHIVED = 'LOCKER_KEY_GROUP_ARCHIVED',
  HOLDER_NOT_IN_ORGANIZATION = 'LOCKER_KEY_HOLDER_NOT_IN_ORGANIZATION',
  INVALID_VALID_UNTIL = 'LOCKER_KEY_INVALID_VALID_UNTIL',
  RANGE_TOO_LARGE = 'LOCKER_KEY_RANGE_TOO_LARGE',
  INVALID_ARRIVAL_REFERENCE = 'LOCKER_KEY_INVALID_ARRIVAL_REFERENCE',
}

export const LOCKER_KEY_MAX_GROUPS = 100;
export const LOCKER_KEY_MAX_NUMBERS_PER_GROUP = 500;
export const LOCKER_KEY_MAX_VALIDITY_DAYS = 366;
export const LOCKER_KEY_INT_MAX = 2147483647;
